import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Flex } from 'components';

import colors from 'lib/colors';

import GameStatuIcon from '../GameStatusIcon';

import { SceneStatusFilterEnum } from './MatchView';

interface Props {
  level: 'INFO' | 'WARN';
  icon?: SceneStatusFilterEnum;
}

const MatchViewMessage: React.FunctionComponent<Props> = ({
  level,
  icon,
  children,
}) => {
  return (
    <Flex
      alignItems="center"
      my={2}
      css={css`
        border-radius: 4px;
        padding-left: 20px;
        padding-right: 20px;
        border-style: solid;
        border-width: 3px;
        border-color: ${level === 'INFO' ? colors.gray : colors.lobbyOrange};
      `}
    >
      <FlexColIcon>
        {icon && <GameStatuIcon iconKey={icon} css={{ width: 50 }} />}
      </FlexColIcon>
      <FlexColMessage>{children}</FlexColMessage>
      <FlexColIcon />
    </Flex>
  );
};

const FlexColIcon = styled('div')({
  width: '100%',
  maxWidth: 50,
});
const FlexColMessage = styled('div')({
  textAlign: 'center',
  paddingTop: 20,
  paddingBottom: 20,
  width: '100%',
});

export default MatchViewMessage;
